import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Habit, HabitCompletion } from './challenge.model';

@Component({
    selector: 'app-habit-card',
    templateUrl: './habit-card.component.html',
    styleUrls: ['./habit-card.component.scss'],
    standalone: false
})
export class HabitCardComponent implements OnChanges, OnDestroy {
  @Input() habit!: Habit;
  @Input() todayCompletion: HabitCompletion | null = null;
  @Input() last7Days: { date: string, completed: boolean }[] = [];
  @Input() streak = 0;

  @Output() toggle = new EventEmitter<void>();
  @Output() noteChange = new EventEmitter<{ completionId: string, note: string }>();
  @Output() editHabit = new EventEmitter<void>();

  noteExpanded = false;
  draftNote = '';
  private noteTimeout: ReturnType<typeof setTimeout> | null = null;

  get isComplete(): boolean { return this.todayCompletion !== null; }
  get hasNote(): boolean { return !!(this.draftNote?.trim()); }

  get showNotesArea(): boolean {
    return this.isComplete && (this.noteExpanded || this.hasNote);
  }

  get showAddNoteButton(): boolean {
    return this.isComplete && !this.showNotesArea;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['todayCompletion']) {
      this.draftNote = this.todayCompletion?.note ?? '';
      this.noteExpanded = false;
    }
  }

  ngOnDestroy(): void {
    if (this.noteTimeout) {
      clearTimeout(this.noteTimeout);
      if (this.todayCompletion) {
        this.noteChange.emit({ completionId: this.todayCompletion.id, note: this.draftNote });
      }
    }
  }

  doToggle() { this.toggle.emit(); }
  doEdit(ev: Event) { ev.stopPropagation(); this.editHabit.emit(); }

  expandNote() { this.noteExpanded = true; }

  onNoteInput(value: string) {
    this.draftNote = value;
    if (!this.todayCompletion) return;
    if (this.noteTimeout) clearTimeout(this.noteTimeout);
    const completionId = this.todayCompletion.id;
    this.noteTimeout = setTimeout(() => {
      this.noteChange.emit({ completionId, note: this.draftNote });
      this.noteTimeout = null;
    }, 500);
  }

  onNoteBlur() {
    if (!this.todayCompletion) return;
    if (this.noteTimeout) { clearTimeout(this.noteTimeout); this.noteTimeout = null; }
    this.noteChange.emit({ completionId: this.todayCompletion.id, note: this.draftNote });
  }
}
